export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  const header = document.querySelector("header");
  const headerH = header ? header.offsetHeight : 72;
  // Land the visitor directly on the section's content: account for the fixed
  // header AND glide past most of the section's top padding so there's no
  // dead space to scroll through.
  const padTop = parseFloat(getComputedStyle(el).paddingTop) || 0;
  const into = Math.max(padTop - 88, 0);
  const offset = -headerH - 8 + into;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.2 });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
};
